var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 18,
    viewBox: "0 0 106 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.85686 1.16327L11.2406 6.24123L16.5712 7.06052L12.714 11.0109L13.6243 16.5918L8.85686 13.9555L4.08944 16.5918L4.99972 11.0109L1.14258 7.06052L6.47315 6.24123L8.85686 1.16327Z",
    fill: "#F2994A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8569 1.16327L33.2406 6.24123L38.5712 7.06052L34.714 11.0109L35.6243 16.5918L30.8569 13.9555L26.0894 16.5918L26.9997 11.0109L23.1426 7.06052L28.4732 6.24123L30.8569 1.16327Z",
    fill: "#F2994A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8569 1.16327L55.2406 6.24123L60.5712 7.06052L56.714 11.0109L57.6243 16.5918L52.8569 13.9555L48.0894 16.5918L48.9997 11.0109L45.1426 7.06052L50.4732 6.24123L52.8569 1.16327Z",
    fill: "#F2994A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8569 1.16327L77.2406 6.24123L82.5712 7.06052L78.714 11.0109L79.6243 16.5918L74.8569 13.9555L70.0894 16.5918L70.9997 11.0109L67.1426 7.06052L72.4732 6.24123L74.8569 1.16327Z",
    fill: "#F2994A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8569 1.16327L99.2406 6.24123L104.571 7.06052L100.714 11.0109L101.624 16.5918L96.8569 13.9555L92.0894 16.5918L92.9997 11.0109L89.1426 7.06052L94.4732 6.24123L96.8569 1.16327Z",
    fill: "white",
    stroke: "#F2994A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.ca2efb3994ca907a0642caaf40d4af4e.svg";
export { ForwardRef as ReactComponent };